import { ChangeEvent } from 'react'

import CopyToClipboard from '@src/components/CopyToClipboard'
import { Address } from '@src/types/token'

interface IDestinationWalletInputProps {
    isVisible: boolean
    destinationAddress: Address | undefined
    isValidDestination: boolean
    chainName: string

    onChangeAddress: (e: ChangeEvent<HTMLInputElement>) => void
}

export function DestinationWalletInput(props: IDestinationWalletInputProps) {
    const { isVisible, destinationAddress, isValidDestination, chainName, onChangeAddress } = props

    if (!isVisible) {
        return null
    }

    return (
        <div className='relative mt-4'>
            <input
                className='w-full rounded-xl border border-[#2A2C3180] bg-transparent px-5 py-3 text-xs'
                value={destinationAddress}
                onChange={onChangeAddress}
                placeholder={`Add receiver wallet on ${chainName}`}
                spellCheck={false}
            />
            {!!destinationAddress && (
                <div className='absolute right-4 top-[50%] -translate-y-1/2'>
                    <CopyToClipboard textToCopy={destinationAddress} anchorId='dest-address-3' />
                </div>
            )}
            {!isValidDestination && destinationAddress && destinationAddress.length > 0 && (
                <span className='text-xs text-rose-600'>Not a valid {chainName} wallet address</span>
            )}
        </div>
    )
}
